
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class MFGTransactionLossGrid extends Serenity.EntityGrid<MFGTransactionLossRow, any> {
        protected getColumnsKey() { return 'Production.MFGTransactionLoss'; }
        protected getDialogType() { return MFGTransactionLossDialog; }
        protected getIdProperty() { return MFGTransactionLossRow.idProperty; }
        protected getInsertPermission() { return MFGTransactionLossRow.insertPermission; }
        protected getLocalTextPrefix() { return MFGTransactionLossRow.localTextPrefix; }
        protected getService() { return MFGTransactionLossService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}